import { LoadingButton } from '@mui/lab';
import { DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { useMutation } from '@tanstack/react-query';
import { queryClient, adminService } from 'services';

type PopupProps = PopupController & {
  id: string;
};

const PopupDelete = ({ id, onClose }: PopupProps) => {
  const { mutate: deleteNetwork, isLoading } = useMutation(adminService.deleteNetwork, {
    onSuccess: () => {
      queryClient.invalidateQueries(['adminService.fetchListenerConfigs']);
      onClose();
    },
  });

  const handleDelete = () => {
    deleteNetwork({ id });
  };

  return (
    <>
      <DialogTitle>CONFIRMATION</DialogTitle>

      <DialogContent>
        Are you want to <span className='font-bold text-red-700'>DELETE</span> ?
      </DialogContent>

      <DialogActions>
        <LoadingButton variant='text' color='inherit' onClick={onClose}>
          Cancel
        </LoadingButton>
        <LoadingButton variant='contained' loading={isLoading} onClick={handleDelete}>
          Confirm
        </LoadingButton>
      </DialogActions>
    </>
  );
};

export default PopupDelete;
